export default "__VITE_ASSET__DmvIWrq1__"